import React from "react";

export default function JS_Super() {
  return (
    <div className="tutorial-container">
      <h1>JS Super</h1>
      <p>This tutorial explains the concept of JS Super in JavaScript OOPs.</p>
    </div>
  );
}
